import { Base } from './_base.model';

export class Notification extends Base {
  id: number;
  types: string[];
  notification_category_id: string;
  event_card_category_id: string;
  object_page: string;
  name: string;
  description: string;
  subject: string;
  is_default: boolean;
  is_critical: boolean = false;
  content: string;
}
